import {GetterTree} from "vuex";
import PeopleSearchWidgetState from "@/apps/PeopleSearchWidget/models/people-search-widget-state";
import {Query} from "@/shared/services/azure-search-service";

export default <GetterTree<PeopleSearchWidgetState, PeopleSearchWidgetState>>{
    config(state) {
        return state.config;
    },

    labels(state) {
        return state.config ? state.config.labels : {}
    },

    loading(state) {
        return state.loading;
    },

    innerLoading(state) {
        return state.innerLoading;
    },

    error(state) {
        return state.error;
    },

    errorText(state, getters) {
        return getters.config.language.toLowerCase() === "nl"
            ? "Er gaat iets fout, probeer het later nog een keer"
            : "Something went wrong, please try again later";
    },

    azureService(state) {
        return state.azureService;
    },

    query: (state, getters) => (all: boolean = false) => {
        let searchQuery = getters.searchQuery.trim().replace(/ /g, '+');
        return new Query()
            .SetSearch(searchQuery)
            .SetCount(true)
            .SetSkip(getters.skipResults)
            .SetTop(all ? getters.totalResults : getters.config.resultsPerPage)
            .SetOrderBy(getters.config.resultsOrder);
    },

    searchQuery(state) {
        return state.searchQuery;
    },

    totalResults(state) {
        return state.totalResults;
    },

    results(state) {
        return state.results;
    },

    lastResult(state) {
        return state.totalResults <= state.results.length;
    },

    skipResults(state) {
        return state.currentPage * state.config.resultsPerPage;
    },

    currentPage(state) {
        return state.currentPage;
    }
}
